var _g, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_473_9811)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.1277,
    cy: 42.2944,
    r: 30.7983,
    fill: "#FB0000",
    fillOpacity: 0.63,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.1813 29.5991C41.0878 29.1987 43.0536 29.1987 44.96 29.5991C45.7846 29.7723 46.4196 30.4489 46.5564 31.3003L46.6256 31.7302C46.7434 32.463 46.8373 33.1987 46.9072 33.9363C46.9164 34.033 46.8826 34.1287 46.8156 34.1974L45.6393 35.4032C45.4428 35.6046 45.1044 35.4698 45.0869 35.1855C45.022 34.1362 44.906 33.0893 44.7387 32.0489L44.6696 31.619C44.6616 31.5692 44.6244 31.5296 44.5761 31.5195C42.923 31.1722 41.2183 31.1722 39.5652 31.5195C39.517 31.5296 39.4798 31.5692 39.4718 31.619L39.4027 32.0489C38.8889 35.2443 38.8583 38.5005 39.3108 41.7031C39.3253 41.8057 39.2921 41.9094 39.2206 41.9827L38.0501 43.1824C37.8904 43.3462 37.6217 43.2886 37.5849 43.0602L37.5158 42.6303C36.9355 39.0212 36.9355 35.3392 37.5158 31.7302L37.5849 31.3003C37.7218 30.4489 38.3567 29.7723 39.1813 29.5991Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.0055 39.1272L53.5833 32.3846C53.9567 32.0019 53.9567 31.3813 53.5833 30.9986C53.2099 30.6158 52.6045 30.6158 52.2311 30.9986L31.833 51.9076C31.4596 52.2903 31.4596 52.9109 31.833 53.2936C32.2064 53.6764 32.8118 53.6764 33.1852 53.2936L36.5365 49.8584C36.5396 49.8588 36.5426 49.8592 36.5457 49.8596C38.0631 50.0583 39.5882 50.1748 41.1146 50.2091V55.4756C41.1146 56.0169 41.5426 56.4557 42.0707 56.4557C42.5988 56.4557 43.0269 56.0169 43.0269 55.4756V50.2091C44.5532 50.1748 46.0783 50.0583 47.5957 49.8596C49.5471 49.6041 51.0912 48.043 51.3672 46.0463L51.9415 41.8916C52.0156 41.3556 51.6518 40.8596 51.129 40.7837C50.6061 40.7077 50.1222 41.0806 50.0481 41.6166L49.4738 45.7713C49.3186 46.8939 48.4505 47.7716 47.3534 47.9152C44.339 48.3099 41.2931 48.3654 38.2698 48.0817L41.2401 45.037C42.4836 45.1107 43.7341 45.0188 44.96 44.7613C45.7846 44.5881 46.4196 43.9115 46.5564 43.0602L46.6256 42.6303C46.8123 41.4685 46.939 40.2992 47.0055 39.1272ZM44.8848 41.301L43.1776 43.051C43.6463 43.0082 44.1132 42.9382 44.5761 42.841C44.6244 42.8308 44.6616 42.7913 44.6696 42.7414L44.7387 42.3115C44.7927 41.9753 44.8415 41.6384 44.8848 41.301Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6676 45.7713C34.6901 45.9342 34.7276 46.0919 34.7787 46.2429C34.822 46.3713 34.798 46.5161 34.7043 46.6121L33.7327 47.608C33.5902 47.7541 33.3523 47.7297 33.2565 47.5481C33.0149 47.0905 32.8485 46.5842 32.7742 46.0463L32.1998 41.8916C32.1258 41.3556 32.4895 40.8596 33.0124 40.7837C33.5352 40.7077 34.0192 41.0806 34.0932 41.6166L34.6676 45.7713Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_473_9811",
    x: 0.542409,
    y: 0.709157,
    width: 83.1706,
    height: 83.1715,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.39347
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_473_9811"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_473_9811",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicOff);
export default __webpack_public_path__ + "static/media/MicOff.79536d71db216971ff276b342ef07277.svg";
export { ForwardRef as ReactComponent };